module.exports = __webpack_public_path__ + "files/21f35676d7497b347c9872780cda720a.png";